import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Generale',
    [tabs.restaurant_details]: 'Dettagli ristorante',
    [tabs.order_conversion]: 'Conversione ordini',
    [tabs.external_delivery]: 'Consegna esterna',
    [tabs.mobile_app]: 'App mobile',
    [tabs.customer_success_team]: 'Team customer success',
    [tabs.onboarding_team]: 'Team onboarding',
  },
  date_range: {
    this_month: 'Questo mese',
    last_month: 'Mese scorso',
    last_week: 'Settimana scorsa',
    last_year: 'Anno scorso',
    this_week: 'Questa settimana',
    this_year: "Quest'anno",
    today: 'Oggi',
    yesterday: 'Ieri',
    all: 'Tutti',
  },
};
